import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-send",
  "use": "icon-send-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-send\"><path d=\"M0 1024l106.496-474.112 588.8-36.864-588.8-39.936-106.496-473.088 1024 512z\" p-id=\"10429\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol